import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Heart, Compass, Sparkles, Lock } from "lucide-react";

const PERKS = [[Heart, "Your own wall"], [Compass, "Follow top vendors"], [Sparkles, "Daily stories"], [Lock, "Private by default"]];

export function SocialPromo() {
  return (
    <section className="px-6 md:px-12 py-16 md:py-24" data-testid="home-social-promo">
      <div className="container-wide relative overflow-hidden rounded-[2.5rem] bg-[#0B0B0B] text-white grid lg:grid-cols-[1.1fr_1fr]">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_10%_0%,rgba(201,162,90,0.3),transparent_60%)]" />
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="relative p-8 md:p-14">
          <p className="font-script text-[#C9A25A] text-4xl">New · The Social Center</p>
          <h2 className="font-serif font-light text-4xl md:text-5xl leading-tight mt-2">Couples, guests and wedding pros, all in one room.</h2>
          <p className="text-white/70 mt-4 max-w-lg">Get your own wall, discover and follow the best local vendors, watch their stories, message them and shop the marketplace. It's free to join.</p>
          <div className="grid grid-cols-2 gap-3 mt-7 max-w-md">{PERKS.map(([I, t]) => <p key={t} className="flex items-center gap-2 text-sm"><I className="w-4 h-4 text-[#C9A25A]" />{t}</p>)}</div>
          <div className="flex flex-wrap gap-3 mt-8">
            <Link to="/join/social" className="btn-gold" data-testid="home-social-join">Join free</Link>
            <Link to="/hub" className="rounded-full px-6 py-3 text-sm font-semibold border border-white/30 hover:bg-white/10 transition-colors" data-testid="home-social-explore">Explore the Social Center</Link>
          </div>
        </motion.div>
        <div className="relative min-h-[320px] lg:min-h-full">
          <img src="https://images.unsplash.com/photo-1518757535402-49f315ea55f6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" alt="Guest capturing a wedding moment" className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#0B0B0B] via-transparent to-transparent hidden lg:block" />
        </div>
      </div>
    </section>
  );
}
